import type { CommentExtension as CommentModel } from 'tio-data/data/resources/comment.ext';

/**
 * Tags whose comments an employee is allowed to see.
 *
 * Approver-tagged comments are internal review notes and must never surface on an
 * employee-facing surface. Lives in tio-common because both the shared comments
 * drawer (`tas/comments/content.gts`'s `employeeComments`) and the employee manage
 * screen (its "Latest Comment" card and the toolbar's unread badge) have to answer
 * this identically — a per-component copy is how the two silently drift apart.
 */
export const EMPLOYEE_VISIBLE_COMMENT_TAGS = ['employee', 'Partner Messaging'];

/**
 * Employee-visible comments, newest first.
 *
 * `isNew` excludes records that are still saving (or failed to save) — a local
 * record with no server identity yet. Without that check an in-flight comment
 * could show as the newest one, and would have no id to track read state against.
 */
export function employeeVisibleComments(
  comments: CommentModel[] | undefined | null
): CommentModel[] {
  return (comments ? [...comments] : [])
    .filter((comment) => !comment.isNew)
    .filter((comment) => comment.tags?.some((tag) => EMPLOYEE_VISIBLE_COMMENT_TAGS.includes(tag)))
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
}
